var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OrgUnitsFilterSelect } from '@web/components/Filters/Elements/OrgUnits';
import { PeriodFilter } from '@web/components/Filters/Elements/Period';
import { UsersFilterSelect } from '@web/components/Filters/Elements/Users';
import { FiltersWidget } from '@web/components/Filters/Elements/Widget';
import SearchBar from '@web/components/layout/SearchBar';
import { useDebouncedCallback } from '@web/utility/hooks/useDebounce';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
var DOC_ALERTS_SEARCH_DEBOUNCE_MS = 300;
var DocAlertsFilters = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var navigateTo = useNavigateTo();
    var docSearch = useFilters().docSearch;
    var _a = useState(function () { return docSearch || ''; }), inputValue = _a[0], setInputValue = _a[1];
    useEffect(function () {
        setInputValue(docSearch || '');
    }, [docSearch]);
    var debouncedNavigate = useDebouncedCallback(function (query) {
        navigateTo({
            pathname: location.pathname,
            newFilters: { docSearch: query }
        });
    }, DOC_ALERTS_SEARCH_DEBOUNCE_MS, docSearch);
    function onQueryChange(query) {
        setInputValue(query);
        debouncedNavigate(query);
    }
    return (_jsxs(FiltersWidget, { children: [_jsxs("div", __assign({ className: "md:w-3/12" }, { children: [_jsx("label", __assign({ htmlFor: "search", className: "block mb-2 text-sm font-medium leading-6 text-gray-900" }, { children: t('docAlerts.searchFilterLabel') })), _jsx(SearchBar, { placeholder: t('docAlerts.searchFilterPlaceholder'), query: inputValue, setQuery: onQueryChange })] })), _jsx(OrgUnitsFilterSelect, { resetUserOnAll: true }), _jsx(UsersFilterSelect, { label: 'filters.triggeredBy' }), _jsx(PeriodFilter, {})] }));
};
export default DocAlertsFilters;
